import type { ReactNode } from "react";
import type { IFlightScheduleChangeModalData } from "@tenant/flights";
import { Button, ButtonTypeEnum } from "@tenant/ui";

export interface IFlightScheduleChangeContactAirlineProps {
  classNames?: Partial<{
    airlineBookingDetails: string;
    airlineLocator: string;
    airlineLocatorLabel: string;
    closeBtn: string;
    contentActions: string;
    contentBody: string;
    contentHeader: string;
    contentSubtitle: string;
    contentTitle: string;
    root: string;
    successImage: string;
    visitAirlineBtn: string;
  }>;
  scheduleChangeDataModel: IFlightScheduleChangeModalData;
  successImage?: ReactNode;
}

export const FlightScheduleChangeContactAirline = (
  props: IFlightScheduleChangeContactAirlineProps
) => {
  const {
    classNames,
    scheduleChangeDataModel: { context, handlers, text },
    successImage,
  } = props;

  return (
    <div className={classNames?.root}>
      <div className={classNames?.contentHeader}>
        <span className={classNames?.contentTitle}>
          {text.contactAirline.title}
        </span>
        <span className={classNames?.contentSubtitle}>
          {text.contactAirline.body}
        </span>
      </div>
      <div className={classNames?.contentBody}>
        {context.changedSlicesAirlines.map((airline) => (
          <div className={classNames?.airlineBookingDetails} key={airline.code}>
            <span className={classNames?.airlineLocator}>
              {airline.locator ?? airline.code}
            </span>
            <span className={classNames?.airlineLocatorLabel}>
              {text.contactAirline.airlineLocatorLabel(airline.code)}
            </span>
          </div>
        ))}
        {successImage == null ? null : (
          <div className={classNames?.successImage}>{successImage}</div>
        )}
      </div>
      <div className={classNames?.contentActions}>
        <Button
          buttonType={ButtonTypeEnum.Secondary}
          className={classNames?.closeBtn}
          onClick={handlers.closeModal}
        >
          {text.contactAirline.closeBtn}
        </Button>
        {context.changedSlicesAirlines.map((airline) => (
          <Button
            buttonType={ButtonTypeEnum.Primary}
            className={classNames?.visitAirlineBtn}
            key={airline.code}
            onClick={() => handlers.visitAirline(airline.code)}
          >
            {text.contactAirline.visitAirlineBtn(airline.code)}
          </Button>
        ))}
      </div>
    </div>
  );
};
